export enum MyDeviceReturningPath {
  dashboard = 'dashboard',
  myaccount = 'my-account',
}
